import profile from '../../Assets/Images/Artists/09/profile_hidden.jpg'

const text =`Social media became to be adopted world wide and part of contemporary culture connecting people all over the world. Despite its benefits, social networks had side effects on our privacy and the time we spend engaging with our devices both.

Today we are faced with an interesting environment where a lot of the content exposed to us is presumably wanted but consumed automatically, often without a conscious decision taking place.

The experience of the webdrop relies on our sense of curiosity and exploration to induce content consumption with a conscious choice taking place, you got here because you purposefully wanted to rather than through a link that showed up on your feed (hopefully). There are no UX patterns specially designed to keep you here, there are no rewards to make you come back. There’s nothing wrong with adding features that increase the engagement of a product, but it’s good to create spaces like this too, that are about spontaneous interaction and sharing creations with the web.

We live for the network. Connected by the invisible cord from us to our digital selves, giving what we got to get something back.`

const project1 = {
  title: 'Webdrop',
  year: 2018,
  content: [
    {
      type: 'text',
      writting: [
        {
          title: 'We live for the network',
          text: text
        }
      ]
    }
  ]
}

const projects = [
  project1,
]

const user = {
  username: 'almdc',
  name: 'Almeida C.',
  url: 'https://www.csalmeida.com/',
  avatar: profile,
  seen: false,
  anonymous: true,
  projects: projects
}

export default user



// WEBPACK FOOTER //
// ./src/Data/Users/almdc.js